<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4.h6.basic800--text {{ $t('add_payment_method') }}
      v-divider.basic400
      v-card-text.pt-4.px-4.pb-0
        v-form(ref="form")
          .label.basic600--text.text-uppercase {{$t('payment_method.label')}}
          v-text-field.mt-2(v-model='name' :placeholder="$t('payment_method.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
      
      v-card-actions.pb-4.px-4
        v-spacer
        v-btn(text='', @click='showModal = false' :disabled="loading" depressed height=32)
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn(color='textColorAccent' depressed height=32 @click='clickSave' :loading="loading")
          .button-AA-small.basic100--text| {{ $t('add') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddPaymentMethod',
  props: ['open', 'company'],
  data: () => ({
    loading: false,
    name: null,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      not_empty_select: [v => !!v || 'This field is required'],
    },
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      let data = {
        name: this.name
      }
      this.$axios.post(`/pos/${this.company.slug}/payment_methods`, data)
        .then(() => {
          this.$emit('refresh')
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "payment_method": {
      "label": "Payment method",
      "placeholder": "Enter payment method"
    }
  },
  "id": {
    "payment_method": {
      "label": "Payment method",
      "placeholder": "Enter payment method"
    }
  }
}
</i18n>